exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.OrderOpen__container__4s5sE {\n  display: flex;\n  flex-wrap: wrap;\n  background-color: #fff;\n  padding-top: 20px; }\n  @media (min-width: 768px) {\n    .OrderOpen__container__4s5sE .OrderOpen__order-data__1LDuf {\n      padding-left: 50px;\n      padding-top: 15px; } }\n  .OrderOpen__container__4s5sE .OrderOpen__order-data__1LDuf p {\n    font-size: 16px;\n    color: #000; }\n    .OrderOpen__container__4s5sE .OrderOpen__order-data__1LDuf p.OrderOpen__BUY__2tDQz {\n      color: #0070DD; }\n    .OrderOpen__container__4s5sE .OrderOpen__order-data__1LDuf p.OrderOpen__SELL__4Dcem {\n      color: #e25656; }\n    .OrderOpen__container__4s5sE .OrderOpen__order-data__1LDuf p span {\n      color: #000;\n      font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"container": "OrderOpen__container__4s5sE",
	"order-data": "OrderOpen__order-data__1LDuf",
	"BUY": "OrderOpen__BUY__2tDQz",
	"SELL": "OrderOpen__SELL__4Dcem"
};